import {useEffect, useState} from "react";
import {Link, useLocation} from "react-router-dom";
import NavbarMenu from "./navbar-menu";
import {AppRoutes} from "../../utils/constants";

function Navbar(props) {

  const [collapsed, setCollapsed] = useState(true);
  const location = useLocation();

  useEffect(() => {
    //hide menu on navigate
    setCollapsed(true);
  }, [setCollapsed, location]);

  return (
    <>
      <div className="navbar-custom topnav-navbar bg-pattern">
        <div className="container">

          <Link to={AppRoutes.landing.path} className="topnav-logo">
            <span className="topnav-logo-lg">
              <img src="/images/logo.png" alt="" height="35" />
            </span>
            <span className="topnav-logo-sm">
              <img src="/images/logo-sm.png" alt="" height="16" />
            </span>
          </Link>

          <ul className="navbar-nav list-unstyled topbar-menu">
            {/*<li className="dropdown notification-list topbar-dropdown d-none d-lg-block">*/}
            {/*  <NavbarLanguages />*/}
            {/*</li>*/}
            {/*<li className="dropdown notification-list">*/}
            {/* <NavbarNotifications />*/}
            {/*</li>*/}
            {/*<li className="dropdown notification-list float-end">*/}
            {/*  <NavbarProfile />*/}
            {/*</li>*/}
          </ul>

          <a className="navbar-toggle navbar-light"
                  onClick={(event)=>setCollapsed(!collapsed)}
                  type="button"
                  aria-controls="main-menu"
                  aria-expanded={ !collapsed }
                  aria-label="Toggle navigation">
            <div className="lines">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </a>

        </div>
      </div>

      <div className="topnav sticky-top">
        <div className="container active">
          <nav className="navbar navbar-dark navbar-expand-lg topnav-menu">
            <div className={`collapse navbar-collapse active ${collapsed ? '' : ' show' } justify-content-between`} id="topnav-menu-content">
              <NavbarMenu />
            </div>
          </nav>
        </div>
      </div>

    </>
  );
}

export default Navbar
